var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Mastercard_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Mastercard_svg__st4{display:none}.Mastercard_svg__st5{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}")), /*#__PURE__*/React.createElement("path", {
    d: "M38 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h36c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 5.9h6.8v12.3h-6.8z",
    style: {
      fill: "#ff5a00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mastercard_svg__XMLID_1_",
    d: "M17 12c0-2.5 1.2-4.7 3-6.1-1.3-1-3-1.7-4.8-1.7-4.3 0-7.8 3.5-7.8 7.8s3.5 7.8 7.8 7.8c1.8 0 3.5-.6 4.8-1.7-1.8-1.4-3-3.6-3-6.1",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6 12c0 4.3-3.5 7.8-7.8 7.8-1.8 0-3.5-.6-4.8-1.7 1.8-1.4 3-3.7 3-6.1s-1.2-4.7-3-6.1c1.3-1 3-1.7 4.8-1.7 4.3 0 7.8 3.5 7.8 7.8",
    style: {
      fill: "#f79e1b"
    }
  }));
};
export default SvgMastercard;